export const META_ATTACH_ADD = 'META_ATTACH_ADD';
export const META_ATTACH_POPULATE = 'META_ATTACH_POPULATE';
export const META_ATTACH_COPY = 'META_ATTACH_COPY';
export const META_ATTACH_CLEAR = 'META_ATTACH_CLEAR';

export const META_ATTACH_REQUEST = 'META_ATTACH_REQUEST';
export const META_ATTACH_SUCCESS = 'META_ATTACH_SUCCESS';
export const META_ATTACH_FAILURE = 'META_ATTACH_FAILURE';

export const META_COPY_REQUEST = 'META_COPY_REQUEST';
export const META_COPY_SUCCESS = 'META_COPY_SUCCESS';
export const META_COPY_FAILURE = 'META_COPY_FAILURE';

export const META_ATTACH_GET_UMO_METATAGS_REQUEST = 'META_ATTACH_GET_UMO_METATAGS_REQUEST';
export const META_ATTACH_GET_UMO_METATAGS_SUCCESS = 'META_ATTACH_GET_UMO_METATAGS_SUCCESS';
export const META_ATTACH_GET_UMO_METATAGS_FAILURE = 'META_ATTACH_GET_UMO_METATAGS_FAILURE';
